import './FabRegistration.css';

function FabRegistration() {
  return (
    <div className="fab-registration">
      <section className="fab-registration-section section-wrapper">
        <div className="section-content">
        <h1>FAB Divisions</h1>
        <ul>
          <li><strong>Division 1 (D1)</strong> - FAB's highest competitive tier – not for the faint of heart.</li>
          <li><strong>Division 2 (D2)</strong> - For casual players looking for vigorous competition.</li>
          <li><strong>Division 3 (D3)</strong> - For casual players looking for less vigorous competition.</li>
          <li><strong>Division 4 (D4)</strong> - Our Rebound league for those easing back into the game.</li>
          <li><strong>Division 5 (D5)</strong> - Our “I just came for the free hotdog” league.</li>
        </ul>
        </div>
      </section>

      <hr className="registration-divider" />

      <section className="fab-registration-section section-wrapper">
        <div className="section-content">
        <h1>SUMMER 2025 Locations & Start Dates</h1>
          <ul>
            <li>
              <a href="https://www.google.com/maps/place/Fountain+Valley+Recreation+Center/@33.7251761,-117.9561271,17z/data=!3m1!4b1!4m5!3m4!1s0x80dd270954e8f7f1:0x3248bdc7e58d5982!8m2!3d33.7253283!4d-117.9539451?shorturl=1" target="_blank" rel="noopener noreferrer">
                Fountain Valley Recreational Center & Sports Park
              </a> (Mon 7–10pm) | D2/D3 | Starts 06/02/2025
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Fountain+Valley+Recreation+Center/@33.7251761,-117.9561271,17z/data=!3m1!4b1!4m5!3m4!1s0x80dd270954e8f7f1:0x3248bdc7e58d5982!8m2!3d33.7253283!4d-117.9539451?shorturl=1" target="_blank" rel="noopener noreferrer">
                Fountain Valley Recreational Center & Sports Park
              </a> (Tues 7–10pm) | D2/D3 | Starts 06/03/2025
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1" target="_blank" rel="noopener noreferrer">
                Columbus Tustin Recreation Center
              </a>  (Tues 6–10pm) | D3 | Starts 05/13/2025
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1" target="_blank" rel="noopener noreferrer">
                Columbus Tustin Recreation Center
              </a>  (Thurs 6–10pm) | D2/D3 | Starts 05/15/2025
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Columbus+Tustin+Recreation+Center/@33.7508854,-117.8233367,17z/data=!3m1!4b1!4m5!3m4!1s0x80dcdbd087ed4ddf:0x2532a181a353a747!8m2!3d33.7509214!4d-117.8211428?shorturl=1" target="_blank" rel="noopener noreferrer">
               Columbus Tustin Recreation Center
              </a>  (Sat 8am–12pm) | D3 | Starts 06/07/2025
            </li>
            <li>
              <a href="https://www.google.com/maps/place/Irvine+Valley+College+Hart+Gymnasium/@33.6744695,-117.7801999,17z/data=!4m6!3m5!1s0x80dcdd0eb12fffff:0x2ba70525cbb5fec6!8m2!3d33.674551!4d-117.7776684!15sChlJcnZpbmUgVmFsbGV5IENvbGxlZ2UgR215kgEDZ3lt?shorturl=1" target="_blank" rel="noopener noreferrer">
                Irvine Valley College Hart Gymnasium
              </a> (Sun 6–10pm) | D1/D2/D3 | Starts 06/01/2025
            </li>
          </ul>

        </div>
      </section>

      <hr className="registration-divider" />

      <section className="fab-registration-section3 section-wrapper">
        <div className="section-content">
          <h1>Register Now!</h1>
          <div className="register-info">
            <div className="register-card">
              <div className="register-button-wrap">
                <a href="https://forms.gle/9XV2uybjcEhyWgT79" target="_blank" rel="noopener noreferrer">
                  <button>Team Registration</button>
                </a>
              </div>
              <p>Team Fees of <strong>$800</strong> must be submitted electronically – PLEASE REGISTER BEFORE SUBMITTING PAYMENT.</p>
              <p>Once your team has registered, each player must fill out the player registration form.</p>
            </div>

            <div className="register-card">
              <div className="register-button-wrap">
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSeyQtXpllAtPRg0Ux-fujIhC3yDblZAAQZEfT_Jd-vrRnLvSw/viewform" target="_blank" rel="noopener noreferrer">
                  <button>Player Registration</button>
                </a>
              </div>
            </div>

            <div className="register-card">
              <div className="register-button-wrap">
                <a href="https://docs.google.com/forms/d/e/1FAIpQLSchpRh9jIxuhGPoTMFyluiUfS4BvUakDCke_tFnVsP-qKZmkA/viewform" target="_blank" rel="noopener noreferrer">
                  <button>Free Agent Registration</button>
                </a>
              </div>
              <p>1) Pay <strong>$100</strong> electronically. (Register before payment.)</p>
              <p>2) Jerseys required (light & dark, unique number). Discounts from  <a href="https://www.ocimprints.com/" target="_blank" rel="noopener noreferrer">
                OC Imprints
              </a>.</p>
              <p>Refund Policy – Free agent spots are non-refundable. Special cases credited to next season.</p>
            </div>
          </div>

        </div>
        <div className='register-announcement-wrap'>
        <h1 className="spring-announcement">FALL 2025 REGISTRATION NOW OPEN!!!</h1>
        </div>
      </section>


    </div>
  );
}

export default FabRegistration;
